<template>

    <div>

        <label class="text-sm block tracking-widest py-2" v-if="label" >{{ label }}*</label>
    
        <div class="flex
                    items-center 
                    border-2 
                    border-solid 
                    border-ch-blue 
                    rounded-md
                    overflow-hidden" 

        :style="radioHeight"
        
        >

            <div class="w-full 
                        h-full
                        text-center
                        bg-white
                        border-r 
                        border-solid 
                        border-ch-blue 
                        last:border-0 
                        select-none
                        cursor-pointer"
            
            :key="option.id"
            :class="{ 
                'hover:bg-blue-100': input.id != option.id,
                'text-white': input.id === option.id,
                'bg-ch-blue': input.id === option.id
            }"
            
            v-for="option in options" 

            @click="input = option"
            
            >
            
                <p class="text-sm h-full grid items-center" >{{ option.name }}</p>
            
            </div>

        </div>

    </div>

</template>

<script>

    import { ref, computed, onMounted } from 'vue'

    export default {
    
        name: 'Radio',

        props: {

            label: String,
            options: Array,
            modelValue: Object,
            height: { type: Number, default: 48 }

        },

        setup(props, {emit}) {

            const radioHeight = computed(() => `height: ${props.height}px` )

            const input = computed({
                get: () => props.modelValue,
                set: value => emit( 'update:modelValue', value )
            })

            const preselect = () => {

                input.value = props.options[0]

            }

            onMounted(preselect)

            return {
                input,
                radioHeight
            }

        }

    }

</script>